import { OrderType } from "@dana/Handlers/ProductAvailabilityHandler";
import { setCookie } from "@insite/mobius/utilities/cookies";
import { EMEARegion } from "@dana/Common/Constants";

export const formatDateForFilename = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
};

export const formatDateWithDash = (isEmea: boolean, date: string): string => {
    if (!date) return "";
    
    const match = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return date;

     const [, y, m, d] = match;
    if (isEmea && date) {
        return `${d}-${m}-${y}`;
    }
    return `${m}-${d}-${y}`;
};


export const formatDateRegion = (region: string | undefined, date: string): string => {
    return formatDateWithDash(region === EMEARegion,date);
};

export const formatDateWithSlash = (date: string): string => {
    if (!date) return "";

    const match = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return date;

    const [, y, m, d] = match;
    return `${m}/${d}/${y}`;
};

export const formatDate = (dateString: string, format: string) => {
    // If already in target format, return as-is
    const ddmmyyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;

    if (format === "DD/MM/YYYY" && ddmmyyyyRegex.test(dateString)) {
        return dateString;
    }

    const date = new Date(dateString);

    if (Number.isNaN(date)) return dateString;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return format === "DD/MM/YYYY"
        ? `${day}/${month}/${year}`
        : `${month}/${day}/${year}`;
};

export const formatDateYYYYMMDD = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

export const getRegionSpecificDate = (isEmea: boolean, shipDate: string) => {
    const today = new Date();
    let requestedDate = "";
    if (isEmea && shipDate) {
        const [day, month, year] = shipDate.split("-");
        const productDate = new Date(Number(year), Number(month) - 1, Number(day));
        const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());  // Fresh date-only today
        if (Number.isFinite(productDate.getTime()) && productDate >= todayMidnight) {
            requestedDate = formatDateYYYYMMDD(productDate);
        }
    } else if (shipDate) {
        const [month, day, year] = shipDate.split("-");
        const productDate = new Date(Number(year), Number(month) - 1, Number(day));
        const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        if (Number.isFinite(productDate.getTime()) && productDate >= todayMidnight) {
            requestedDate = formatDateYYYYMMDD(productDate);
        }
    }
    return requestedDate;
}

export const setOrderTypeCartModeCookie = (orderType: string) => {
    setCookie("modalOrderType", orderType);
    if (orderType === "ZSO") {
        setCookie("cartMode", "EmergencyOrderCart");
    } else if (orderType === "ZOR") {
        setCookie("cartMode", "StockOrderCart");
    } else {
        setCookie("modalOrderType", "ZOR");
        setCookie("cartMode", "StockOrderCart");
    }
}


export const getInitialShipDate = (requestedShipDateValue: any) => {
    if (!requestedShipDateValue) { return undefined; }

    let date = new Date(requestedShipDateValue);
    date.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (date.getTime() === today.getTime()) {
        const dayOfWeek = date.getDay();

        if (dayOfWeek === 5) {
            date.setDate(date.getDate() + 3);
        } else if (dayOfWeek === 6) {
            date.setDate(date.getDate() + 2);
        } else {
            date.setDate(date.getDate() + 1);
        }
    }
    return date;
};